import styled from 'styled-components';

export const VendorStyle = styled.div`
  color: #bfbfbf;
  line-height: 20px;
  margin-top: var(--pm-16-8);
`;
